<template>
  <div class="bg-sub">
    <div class="container header-page">
      <div class="poster-offline" v-show="status == 'false'">
        <figure class="sixteen-nine-img">
          <img src="../../src/assets/img/FinalPoster/channeloffline640x480.png">
        </figure>
      </div>
      <div class="player" v-show="status == 'true'">
        <div class="player-site" id="player-site">
          <div class="overlay-public" id="overlay">
            <img src="../assets/img/live.png" class="icon-live-player">
            <!--p class="view-live"><i class="fa fa-eye"></i> {{views}}</p-->
          </div>
          <div class="btn-close" id="close-video" @click="closeSticky()">
            <i class="fa fa-times close-video" aria-hidden="true"></i>
          </div>
          <video id="player-public" class="video-js vjs-default-skin vjs-16-9 full" ref="videoPlayer" height="360"
            controls>
          </video>
        </div>
      </div>

      <!--ul class="nav nav-flex-icons">
            <li v-for="item in publicfeed">
              <btn class="btn-public" color="blue darken-4" @click="PlayPublicFeed(item)">
                <div class="bg-show">
      		        <div class="overlay"></div>
      	        </div>
                <fa icon="plane" class="mr-1" /> <span class="span-btn-public">{{item.name}}</span>
              </btn>
            </li>
          </ul-->

      <div class="title-video mt-4">
        <div class="function-vodpage">
          <!--btn class="btn-fav" type="submit" name="button" @click="FunctionFavorite()">
              <fa icon="heart" class="" v-bind:class="[isActive ? 'icon-fav' : 'icon-fav2']"/>
            </btn>
            <btn class="btn-history" type="submit" name="button" @click="AddWatchLater()">
              <fa icon="history" class="icon-history" />
            </btn-->
          <tooltip trigger="hover" :options="{ placement: 'top' }">
            <div class="tooltip">
              แชร์
            </div>
            <btn slot="reference" class="btn-share" type="submit" name="button" @click.native="modalShare = true"
              @click="ShareLink()">
              <fa icon="share" class="icon-share" />
            </btn>
          </tooltip>
        </div>
        <!--p class="ml-2 text-ip"><span class="text-headip">Server IP : </span>{{serverip}}</p>
          <p class="ml-2 text-ip"><span class="text-headip">Client IP : </span>{{clientip}}</p-->
        <h4 class="ml-2">{{ Title }}</h4>
        <!--p class="ml-2 text-count">กำลังรับชม {{views}} ท่าน</p-->
      </div>

      <div class="detail-video">
        <div class="box-user">
          <img src="../../src/assets/img/FinalPoster/avatar45x45.png" class="avatar-channal">
          <div class="user-detail">
            <p class="nameChannal" v-if="!Publisher">ROYAL THAI AIR FORCE</p>
            <p class="nameChannal" v-if="Publisher">{{ Publisher }}</p>
          </div>
          <div class="description">
            <read-more class="text-desc" more-str="แสดงรายละเอียด" :text="Desc" link="#" less-str="ย่อรายละเอียด"
              :max-chars="200"></read-more>
          </div>
        </div>
      </div>

      <div class="content" v-if="publicfeed.length">
        <div class="header-category">
          <h3 class="header-content-live">Related Channel</h3>
        </div>
        <div class="bigcontent" @click="PlayPublicFeed(publicfirst)">
          <section class="cards-bigcontent">
            <div class="card-bigcontent">
              <div class="">
                <div class="preview-video">
                  <div class="" v-if="publicfirst.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live-big-related">
                  </div>
                  <figure class="sixteen-nine-img">
                    <img :src="publicfirst.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>

                </div>
                <div class="card-content">
                  <p class="card-title">{{ publicfirst.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{publicfirst.views}} ท่าน</p-->
                  <p class="card-desc">{{ publicfirst.desc }}</p>
                </div>
              </div>
            </div>
          </section>
        </div>

        <slick ref="slick" class="slick-related1" :options="slickOptions">
          <div class="video" v-for="video in publicfeed">
            <router-link :to="'/public/' + video.id">
              <div class="" @click="PlayPublicFeed(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{video.views}} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>
            <!--div class="function">
                <btn class="btn-fav" type="submit" name="button" @click="FunctionFavoriteRelate(video)">
                  <fa icon="heart" class="" v-bind:class="[FavoriteActive(video.favorite) ? 'icon-fav' : 'icon-fav2']"/>
                </btn>
                <btn class="btn-history" type="submit" name="button" @click="AddWatchLaterRelated(video)"><fa icon="history" class="icon-history" /></btn>
                <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLinkRelated(video)"><fa icon="share" class="icon-share"/></btn>
              </div-->
          </div>
        </slick>

        <slick ref="slick" class="slick-related2" :options="slickOptions">
          <div class="video" v-for="video in publicSlice">
            <router-link :to="'/public/' + video.id">
              <div class="" @click="PlayPublicFeed(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{video.views}} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>
            <!--div class="function">
                <btn class="btn-fav" type="submit" name="button" @click="FunctionFavoriteRelate(video)">
                  <fa icon="heart" class="" v-bind:class="[FavoriteActive(video.favorite) ? 'icon-fav' : 'icon-fav2']"/>
                </btn>
                <btn class="btn-history" type="submit" name="button" @click="AddWatchLaterRelated(video)"><fa icon="history" class="icon-history" /></btn>
                <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLinkRelated(video)"><fa icon="share" class="icon-share"/></btn>
              </div-->
          </div>
        </slick>
      </div>

      <!-- Modal share -->
      <modal centered v-if="modalShare" @close="modalShare = false">
        <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
        <modal-header>
          <modal-title>Share</modal-title>
        </modal-header>
        <modal-body class="body-share">
          <div class="padding-share">
            <!--div class="text-center input-share">
          <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
        </div-->
            <div class="input-link input-share">
              <input type="text" v-model="Link" id="linkURL" class="form-control shareLink" readonly="readonly">
              <btn color="primary" class="btn-chat" @click="CopyLink()"><span>คัดลอก</span></btn>
            </div>
            <!--div class="">
          <btn class="btn-email" color="white"><fa icon="envelope" class="icon-link" /> อีเมล</btn>
        </div>
        <div class="">
          <btn class="btn-facebook" color="primary"><fa icon="facebook" class="icon-social" /> facebook</btn>
        </div>
        <div class="">
          <btn class="btn-line" color=" green accent-4"><fa icon="line" class="icon-social" />Line</btn>
        </div-->
          </div>

        </modal-body>
      </modal>
      <!-- /Modal share -->


    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
// const videojs = require('video.js');
import videojs from 'video.js';
require('videojs-contrib-hls');
require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Tooltip
} from 'mdbvue';
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
export default {
  name: 'PlayerPublic',
  components: {
    mdbRow,
    mdbCol,
    Btn,
    mdbCard,
    mdbCardBody,
    Fa,
    mdbCardHeader,
    videojs,
    Slick,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Tooltip
  },
  data() {
    return {
      serverip: '',
      clientip: '',
      Desc: '',
      Publisher: null,
      status: '',
      publicfirst: [],
      publicfeed: [],
      publicSlice: [],
      views: '0',
      Link: null,
      isActive: 0,
      favorite: null,
      modalShare: false,
      active: 0,
      elHeight: 0,
      MessageDetail: '',
      Title: '',
      Channal: '',
      message: '',
      stream_url: '',
      player: null,
      msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      Related: [],
      slickOptions: {
        infinite: false,
        prevArrow: "<a class='btn-floating slick-left'><i class='fa fa-chevron-left'></i></a>",
        nextArrow: "<a class='btn-floating slick-right'><i class='fa fa-chevron-right'></i></a>",
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 430,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            autoplay: false
          }
        }]
        // Any other options that can be got from plugin documentation
      },
      playerOptions: {
        height: 500,
        hls: true,
        autoplay: true,
        language: 'en',
        sources: [{
          type: "application/x-mpegURL",
          src: "",
        }],
        flash: {
          hls: { withCredentials: false }
        },
        html5: {
          hls: { withCredentials: false }
        },
        poster: "",
      },
      window: {
        width: 0,
        height: 0
      },
      video: true
    };
  },
  mounted() {
    this.PublicChannel();
    this.FeedPublicChannel();
    localStorage.pincode = '';
    //this.Session();

    axios({ method: "GET", "url": Host + '/ip' }).then(result => {
      this.clientip = result.data.ip;
    }, error => {
      console.error(error);
    });
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    closeSticky() {
      document.getElementById("player-site").classList.remove("player-sticky");
      this.video = false;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      try {
        if (this.window.width <= '414') {
          window.onscroll = () => {
            if (window.pageYOffset >= '40' && this.window.width <= '414' && this.video == true) {
              document.getElementById("player-site").classList.add("player-sticky");
              document.getElementById("close-video").classList.add("display-in");
              document.getElementById("overlay").classList.add("display-none");
            } else {
              document.getElementById("player-site").classList.remove("player-sticky");
              document.getElementById("close-video").classList.remove("display-in");
              document.getElementById("overlay").classList.remove("display-none");
            }
          };
        } else {
          document.getElementById("player-site").classList.remove("player-sticky");
        }
      } catch (e) {
        console.log('');
      }
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession, {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    countViews() {
      let vm = this;
      let liveid = this.$route.params.id;
      vm.active = 1;
      vm.$sails.socket.get('/api/v1/socket/live', function (resData, jwres) {
        vm.$sails.socket.on(liveid, function (view) {
          if (view.views) {
            vm.views = view.views;
          }
        });
      });
    },
    PlayPublicFeed(data) {
      document.location.assign('/#/public/' + data.id);
      location.reload();
      this.PublicChannel();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    FeedPublicChannel() {
      let APIgetFeedPublicChannel = Host + '/api/v1/channel/public';
      axios.get(APIgetFeedPublicChannel).then(response => {
        this.publicSlice = response.data.result.slice(1, response.data.result.length);
        this.publicfirst = response.data.result[0];
        this.publicfeed = response.data.result;
      });
    },
    PublicChannel() {
      let publicid = this.$route.params.id;
      let APIGetPublicChannel = Host + '/api/v1/channel/play';
      axios.post(APIGetPublicChannel, {
        id: publicid,
        email: localStorage.emailfront
      }).then(response => {
        this.countViews();
        this.status = response.data.live;
        if (this.status == 'false') {
          this.stream_url = '';
        } else {
          this.stream_url = response.data.stream_url;
        }
        this.Link = response.data.share;
        this.serverip = this.stream_url;
        this.Publisher = response.data.publisher;
        this.Desc = response.data.desc;
        this.Title = response.data.name;
        //this.views = response.data.views;
        this.playerInitialize();
      })
        .catch(error => {
          console.log(error);
        });
    },
    playerInitialize() {
      this.playerOptions.sources[0].src = this.stream_url;
      this.player = videojs('player-public', this.playerOptions);
      this.player.hlsQualitySelector();
      this.player.play();
    },
    playerDispose() {
      this.player.dispose();
    },
    CopyLink() {
      let coding = document.querySelector('#linkURL');
      coding.setAttribute('type', 'text');
      coding.select();

      try {
        var successful = document.execCommand('copy');
        if (successful == true) {
          this.success();
        }
      }
      catch (err) {
        console.log('error, please copy by Ctrl+C.');
      }
    },
    success() {
      this.$alert.success({ message: 'คัดลอกลิ้งค์แล้ว', position: 'bottom left', timeOut: 3000 });
    },
    beforeEnter(el) {
      this.elHeight = el.scrollHeight;
    },
    enter(el) {
      el.style.height = this.elHeight + 'px';
    },
    beforeLeave(el) {
      el.style.height = 0;
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      // seek to 10s
      console.log('example player 1 readied', player);
      player.currentTime(10);
      // console.log('example 01: the player is readied', player)
    }
  },
  beforeDestroy() {
    this.playerDispose();
  }
};
</script>

<style lang="css">
.text-ip {
  font-size: 12px;
  color: red;
}

.text-headip {
  color: #fff;
}

.video-js .vjs-menu-button-inline.vjs-slider-active,
.video-js .vjs-menu-button-inline:focus,
.video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 5em !important
}

.video-js .vjs-controls-disabled .vjs-big-play-button {
  display: none !important
}

.video-js .vjs-menu-button-inline:before {
  width: 1.5em !important
}

.vjs-menu-button-inline .vjs-menu {
  left: 3em !important
}

.video-js .vjs-mouse-display:after,
.video-js .vjs-play-progress:after {
  padding: 0 .4em .3em !important
}

.video-js.vjs-ended .vjs-loading-spinner {
  display: none !important
}

.video-js.vjs-ended .vjs-big-play-button {
  display: block !important
}

.video-js *,
.video-js:after,
.video-js:before {
  box-sizing: inherit !important;
  font-size: inherit !important;
  color: inherit !important;
  line-height: inherit !important
}

.video-js.vjs-fullscreen,
.video-js.vjs-fullscreen .vjs-tech {
  width: 100% !important;
  height: 100% !important
}

.video-js {
  font-size: 14px !important;
  overflow: hidden !important
}

.video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 8.35em !important
}

.video-js .vjs-volume-menu-button.vjs-volume-menu-button-horizontal:hover .vjs-menu .vjs-menu-content {
  height: 3em !important;
  width: 6.35em !important
}

.vjs-icon-placeholder {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.vjs-icon-placeholder:hover:before {
  text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff !important;
}

/* .video-js .vjs-play-control .vjs-icon-placeholder:hover:before,
.vjs-icon-volume-high:hover:before, .video-js .vjs-mute-control .vjs-icon-placeholder:hover:before {
  text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff !important;
} */

/* .video-js .vjs-control:focus:before,
.video-js .vjs-control:hover:before,
.video-js .vjs-control:focus {
  text-shadow: 0em 0em 1em white !important; } */

.video-js .vjs-spacer,
.video-js .vjs-time-control {
  display: -webkit-box !important;
  display: -moz-box !important;
  display: -ms-flexbox !important;
  display: -webkit-flex !important;
  display: flex !important;
  -webkit-box-flex: 1 1 auto !important;
  -moz-box-flex: 1 1 auto !important;
  -webkit-flex: 1 1 auto !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important
}

.video-js .vjs-time-control {
  -webkit-box-flex: 0 1 auto !important;
  -moz-box-flex: 0 1 auto !important;
  -webkit-flex: 0 1 auto !important;
  -ms-flex: 0 1 auto !important;
  flex: 0 1 auto !important;
  width: auto !important;
  padding-left: 0em;
  padding-right: 0em;
  line-height: 36px !important;
}

.video-js .vjs-time-control.vjs-time-divider {
  width: 14px !important
}

.video-js .vjs-time-control.vjs-time-divider div {
  width: 100% !important;
  text-align: center !important
}

.video-js .vjs-time-control.vjs-current-time {
  margin-left: 1em !important
}

.video-js .vjs-time-control .vjs-current-time-display,
.video-js .vjs-time-control .vjs-duration-display {
  font-size: 1.1em !important;
  width: 100% !important
}

.video-js .vjs-time-control .vjs-current-time-display {
  text-align: right !important
}

.video-js .vjs-time-control .vjs-duration-display {
  text-align: left !important
}


.video-js .vjs-remaining-time,
.video-js.vjs-live .vjs-time-control.vjs-current-time,
.video-js.vjs-live .vjs-time-control.vjs-duration,
.video-js.vjs-live .vjs-time-control.vjs-time-divider,
.video-js.vjs-no-flex .vjs-time-control.vjs-remaining-time {
  display: none !important
}

.video-js.vjs-no-flex .vjs-time-control {
  display: table-cell !important;
  width: 4em !important
}

.video-js .vjs-progress-control {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: 10px !important;
  width: 97.4% !important;
  height: .4em !important;
  top: -1.4em !important
}

.vjs-button>.vjs-icon-placeholder:before {
  font-size: 1.8em;
  line-height: 1.67;
}

.video-js .vjs-progress-control .vjs-load-progress,
.video-js .vjs-progress-control .vjs-play-progress,
.video-js .vjs-progress-control .vjs-progress-holder {
  height: 100% !important
}

.video-js .vjs-play-progress:before,
.video-js .vjs-volume-level:before {
  display: none;
}

.video-js .vjs-progress-control .vjs-progress-holder {
  margin: 0 !important
}

.video-js .vjs-progress-control:hover {
  height: 0.5em !important;
  top: -1.4em !important
}

.video-js .vjs-seek-to-live-control {
  height: 24px;
}

.vjs-volume-bar.vjs-slider-horizontal {
  height: 0.5em;
}

.vjs-slider-horizontal .vjs-volume-level {
  height: 0.5em;
}

.video-js .vjs-control-bar {
  -webkit-transition: -webkit-transform .1s ease 0s !important;
  -moz-transition: -moz-transform .1s ease 0s !important;
  -ms-transition: -ms-transform .1s ease 0s !important;
  -o-transition: -o-transform .1s ease 0s !important;
  transition: transform .1s ease 0s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar {
  visibility: visible !important;
  opacity: 1 !important;
  -webkit-backface-visibility: hidden !important;
  -webkit-transform: translateY(3.5em) !important;
  -moz-transform: translateY(3.5em) !important;
  -ms-transform: translateY(3.5em) !important;
  -o-transform: translateY(3.5em) !important;
  transform: translateY(3.5em) !important;
  -webkit-transition: -webkit-transform 1s ease 0s !important;
  -moz-transition: -moz-transform 1s ease 0s !important;
  -ms-transition: -ms-transform 1s ease 0s !important;
  -o-transition: -o-transform 1s ease 0s !important;
  transition: transform 1s ease 0s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control {
  height: .25em !important;
  top: -.25em !important;
  pointer-events: none !important;
  -webkit-transition: height 1s, top 1s !important;
  -moz-transition: height 1s, top 1s !important;
  -ms-transition: height 1s, top 1s !important;
  -o-transition: height 1s, top 1s !important;
  transition: height 1s, top 1s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control {
  opacity: 0 !important;
  -webkit-transition: opacity 1s ease 1s !important;
  -moz-transition: opacity 1s ease 1s !important;
  -ms-transition: opacity 1s ease 1s !important;
  -o-transition: opacity 1s ease 1s !important;
  transition: opacity 1s ease 1s !important
}

.video-js.vjs-live .vjs-live-control {
  margin-left: 1em !important
}


.vjs-menu-button-popup .vjs-menu {
  bottom: 10px;
}

.video-js .vjs-volume-bar {
  /* margin: 0.7em 0.45em; */
  margin: 1.35em 0.45em;
}

.video-js .vjs-loading-spinner {
  /* border-color: rgba(36, 131, 213, .8) !important */
}

.video-js .vjs-control-bar {
  background-color: transparent !important;
  color: #fff !important;
  font-size: 12px !important;
  text-shadow: 1px 1px 2px black;
  background: linear-gradient(to bottom, rgb(255 255 255 / 0%), rgb(0 0 0 / 52%));
}

.video-js .vjs-play-progress {
  /* background-color: #0199ff !important */
  background-color: #fff !important
}

.video-js .vjs-volume-level {
  background-color: #fff !important
}

.vjs-menu-title {
  display: none !important;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder {
  color: red !important;
}

.video-js .vjs-big-play-button {
  font-size: 5em !important;
  border: none !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  line-height: 1.2em !important;
  height: 1.2em !important;
  width: 1.2em !important;
  border-radius: 50% !important;
  margin-left: -.6em;
  margin-top: -.6em;
}

.vjs-big-play-centered .vjs-big-play-button {
  margin-left: -0.5em !important;
}

.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 56.25% !important;
}

.vjs-icon-cog:before {
  /* content: ""; */
  /* background-image: url('/cog.svg'); */
  background-size: cover;
  /* ปรับขนาด SVG ตามต้องการ */
  width: 100%;
  /* กำหนดความกว้างของ element */
  height: 100%;
  /* กำหนดความสูงของ element */
}

.video-js .vjs-live-control {
  align-items: center;
}

.vjs-menu li {
  line-height: 1.4em !important;
  font-size: 1.2em !important;
}

.vjs-icon-hd:before {
  content: "\F110";
  line-height: 36px !important;
}
.vjs-error .vjs-error-display:before{
  content: "" !important;
}
</style>
